import styled, {css} from 'styled-components';

import {getColor} from '../../styles';
import {ms} from '../../styles/normalizeSize';
import {platform} from '../../utils/platform';
import {NumberTextInput} from '../NumberTextInput';
import {Text} from '../Text';
import {TextInputLikeView} from '../TextInputLikeView';

export const Container = styled(TextInputLikeView)`
  flex-direction: row;
  justify-content: flex-start;

  ${platform.isSafari &&
  css`
    padding: ${ms(14)} ${ms(16)};
  `}
`;

export const TextInput = styled(NumberTextInput)<{isMinutes?: boolean}>`
  border-width: 0;
  padding: 0;
  width: ${ms(17)};
  height: ${ms(14)};
  border-radius: 0;

  ${p =>
    p.isMinutes &&
    css`
      padding: 0 ${ms(1)};
      width: ${ms(18)};
    `}

  ${platform.isSafari &&
  css`
    height: ${ms(17)};
    line-height: 1;
    position: relative;
    top: ${ms(-2)};
  `}
`;

export const Separator = styled(Text)<{isDisabled?: boolean}>`
  height: ${ms(14)};
  line-height: ${ms(14)};

  ${p =>
    p.isDisabled &&
    css`
      color: ${getColor('text3')};
    `}
`;
